import { FUND_SUMMARY_SPREADSHEET_HEADERS } from 'pages/Funds/common/constants/fundSummary/sheetTitles';

const getAdjustedHeaders = (isProcessManagementEnabled: boolean) => {
  if (isProcessManagementEnabled) {
    return FUND_SUMMARY_SPREADSHEET_HEADERS;
  }

  const adjustedHeaders = [
    ...FUND_SUMMARY_SPREADSHEET_HEADERS.slice(0, 1),
    ...FUND_SUMMARY_SPREADSHEET_HEADERS.slice(2),
  ];
  return adjustedHeaders;
};

export default getAdjustedHeaders;
